export const REVOKE_SHARING_REQUEST = 'REVOKE_SHARING_REQUEST'
export function revokeSharingRequest(body) {
    return {
        type: REVOKE_SHARING_REQUEST,
        body
    }
}

export const REVOKE_SHARING_SUCCESS = 'REVOKE_SHARING_SUCCESS'
export function revokeSharingSuccess() {
    return {
        type: REVOKE_SHARING_SUCCESS
    }
}

export const REVOKE_SHARING_ERROR = 'REVOKE_SHARING_ERROR'
export function revokeSharingError() {
    return {
        type: REVOKE_SHARING_ERROR
    }
}

export const SHARING_ENTITIES_REQUEST = 'SHARING_ENTITIES_REQUEST'
export function sharingEntitiesRequest(isGrantedData) {
    return {
        type: SHARING_ENTITIES_REQUEST,
        isGrantedData
    }
}

export const SHARING_ENTITIES_ERROR = 'SHARING_ENTITIES_ERROR'
export function sharingEntitiesError() {
    return {
        type: SHARING_ENTITIES_ERROR
    }
}

export const SHARED_USERS_SUCCESS = 'SHARED_USERS_SUCCESS'
export function sharedUsersSuccess(sharedUsers) {
    return {
        type: SHARED_USERS_SUCCESS,
        sharedUsers
    }
}

export const LOCATIONS_REQUEST_SUCCESS = 'LOCATIONS_REQUEST_SUCCESS'
export function locationsRequestSuccess(locations) {
    return {
        type: LOCATIONS_REQUEST_SUCCESS,
        locations
    }
}

export const DEVICES_REQUEST_SUCCESS = 'DEVICES_REQUEST_SUCCESS'
export function devicesRequestSuccess(devices) {
    return {
        type: DEVICES_REQUEST_SUCCESS,
        devices
    }
}

export const REPORTS_REQUEST_SUCCESS = 'REPORTS_REQUEST_SUCCESS'
export function reportsRequestSuccess(reports) {
    return {
        type: REPORTS_REQUEST_SUCCESS,
        reports
    }
}

export const SET_SELECTED_SHARED_USERS = 'SET_SELECTED_SHARED_USERS'
export function setSelectedSharedUsers(selectedSharedUsers) {
    return {
        type: SET_SELECTED_SHARED_USERS,
        selectedSharedUsers
    }
}

export const SET_SELECTED_LOCATIONS = 'SET_SELECTED_LOCATIONS'
export function setSelectedLocations(selectedLocations) {
    return {
        type: SET_SELECTED_LOCATIONS,
        selectedLocations
    }
}

export const SET_SELECTED_DEVICES = 'SET_SELECTED_DEVICES'
export function setSelectedDevices(selectedDevices) {
    return {
        type: SET_SELECTED_DEVICES,
        selectedDevices
    }
}

export const SET_SELECTED_REPORTS = 'SET_SELECTED_REPORTS'
export function setSelectedReports(selectedReports) {
    return {
        type: SET_SELECTED_REPORTS,
        selectedReports
    }
}

export const SHARE_REQUEST = 'SHARE_REQUEST'
export function shareRequest(selectedLocations, selectedDevices, selectedReports) {
    return {
        type: SHARE_REQUEST,
        selectedLocations,
        selectedDevices,
        selectedReports
    }
}

export const SHARE_SUCCESS = 'SHARE_SUCCESS'
export function shareSuccess() {
    return {
        type: SHARE_SUCCESS
    }
}

export const SHARE_ERROR = 'SHARE_ERROR'
export function shareError() {
    return {
        type: SHARE_ERROR
    }
}
